import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Flex, Hide, Heading } from 'roo-ui/components';
import MapWithMarker from 'components/maps/MapWithMarker';
import GetDirections from 'components/maps/GetDirections';
import formatPropertyAddress from 'components/formatters/FormatPropertyAddress';
import { captureErrorInSentry } from 'lib/errors';

const Title = () => (
  <Box mt="space.4">
    <Hide xs>
      <Heading.h2 color="greys.charcoal" fontSize="md" mb={3}>
        Property location
      </Heading.h2>
    </Hide>
    <Hide sm md lg>
      <Heading.h2 color="greys.charcoal" fontSize="md" mb={3}>
        Location
      </Heading.h2>
    </Hide>
  </Box>
);

const Address = ({ address }) => (
  <Box fontSize="xs">
    {formatPropertyAddress({
      streetAddressLines: address.streetAddress,
      suburb: address.suburb,
      state: address.state,
      country: address.country,
    })}
  </Box>
);

Address.propTypes = {
  address: PropTypes.object.isRequired,
};

const PropertyInfo = ({ property }) => (
  <Flex flexDirection="column" mb={2}>
    <Text fontSize="base" fontWeight="bold">
      {property.name}
    </Text>
    <Address address={property.address} />
  </Flex>
);

PropertyInfo.propTypes = {
  property: PropTypes.object.isRequired,
};

const PropertyMap = ({ property }) => {
  const [mapError, setMapError] = useState(undefined);
  useEffect(() => {
    if (mapError) {
      captureErrorInSentry(mapError);
    }
  }, [mapError]);

  return (
    <Box>
      {!mapError && (
        <Box height={['300px', '400px']} width="100%" pb={8}>
          <MapWithMarker name="property-map" latitude={property.latitude} longitude={property.longitude} lazy onError={setMapError} />
        </Box>
      )}
      <Title />
      <PropertyInfo property={property} />
      <GetDirections address={property.address} />
    </Box>
  );
};

PropertyMap.propTypes = {
  property: PropTypes.object.isRequired,
};

export default PropertyMap;
